export default "__VITE_ASSET__78a9a230__"